/* ==========================================================================
   Desktop Sticky Cart — surprise-gift auto-add/remove (parallel build).

   Faithful port of cart-revamp.liquid `addSurpriseGiftCart` (2713-2865): posts the
   cart to the SAME backend, then applies the returned add/remove instructions via
   /cart/update.js and re-renders the drawer.

     POST /app/cart-suprise-gift-web/v2
       { email, customerId, customerPin, lat, long, original_total_price,
         total_price, item_count, items, items_subtotal_price, edd }
     → response.supriseGifts.addItemsToCart[].variantId      → qty 1
     → response.supriseGifts.removeItemsFromCart[].variant_id → qty 0

   Per-item data (incl. product tags, which /cart.js does not expose) is server-
   rendered into [data-st-surprise-items] by sections/sticky-cart-drawer.liquid.

   Guards: never runs on /cart (the cart page runs its own flow); a single-flight
   lock + a cart signature prevent loops/duplicate calls for the same cart state.

   Exposes window.StickyCartSurpriseGift.apply(scope, { onChange }).
   ========================================================================== */
(function () {
  'use strict';

  var URL = 'https://supertails-backend.el.r.appspot.com/app/cart-suprise-gift-web/v2';
  var inFlight = false;
  var pending = false;        // a render arrived mid-flight → re-run after current finishes
  var lastScope = null;
  var lastOpts = null;
  var lastSig = null;

  function getCpin() {
    var m = document.cookie.match(/(?:^|; )cpin=([^;]*)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function shellCustomer() {
    try {
      var el = document.querySelector('[data-st-offers-customer]');
      if (el) { var j = JSON.parse(el.textContent); return (j && j.customer) || {}; }
    } catch (e) {}
    return {};
  }

  function readItems(scope) {
    var el = (scope || document).querySelector('[data-st-surprise-items]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function sig(items) {
    return items.map(function (i) { return i.id + ':' + i.quantity; }).sort().join('|');
  }

  function apply(scope, opts) {
    opts = opts || {};
    lastScope = scope;
    lastOpts = opts;
    // The cart page (/cart) runs its own addSurpriseGiftCart — don't double-fire.
    if (location.pathname.indexOf('/cart') === 0) return;
    // Mid-flight: don't drop this render — coalesce and re-run once the current request
    // finishes, so the FINAL cart state (e.g. after rapid one-by-one removals) is always
    // reconciled instead of being silently skipped.
    if (inFlight) { pending = true; return; }

    var items = readItems(scope);
    if (!items || !items.length) return;

    var signature = sig(items);
    if (signature === lastSig) return; // already reconciled this exact cart state

    var cust = shellCustomer();
    var loc = {}; try { loc = JSON.parse(localStorage.getItem('userLocation')) || {}; } catch (e) {}
    var guest = {}; try { guest = JSON.parse(sessionStorage.getItem('guestAddress')) || {}; } catch (e) {}
    var edd = null; try { edd = JSON.parse(sessionStorage.getItem('eddWarehouse')); } catch (e) {}

    // AOV excludes free-gift items, summed from original_line_price (parity with 2776-2783).
    var mainItems = items.filter(function (i) { return (i.tags || []).indexOf('free_gift_new') < 0; });
    var totalprice = mainItems.reduce(function (s, i) { return s + (i.original_line_price || 0); }, 0);
    var itemCount = items.reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
    var subtotal = items.reduce(function (s, i) { return s + (i.line_price || 0); }, 0);

    // Parity with cart-revamp addSurpriseGiftCart (2764-2772): if the cart still has lines
    // but its CHARGED total is ~0 (only free gifts left), clear the whole cart. This is the
    // single mechanism that removes the lone free gift after the last real product is removed.
    var chargedTotal = items.reduce(function (s, i) {
      return s + (i.final_line_price != null ? i.final_line_price : (i.line_price || 0));
    }, 0);
    if (chargedTotal <= 1) {
      lastSig = signature;
      inFlight = true;
      fetch('/cart/clear', { method: 'GET', credentials: 'same-origin' })
        .catch(function () {})
        .then(function () {
          inFlight = false;
          lastSig = null; // cart changed (now empty) — allow the next render to reconcile
          if (typeof opts.onChange === 'function') opts.onChange();
          if (pending) { pending = false; apply(lastScope, lastOpts); }
        });
      return;
    }

    var body = {
      email: cust.email || guest.email || '',
      customerId: cust.id != null ? String(cust.id) : '',
      customerPin: getCpin(),
      lat: loc.latitude || '',
      long: loc.longitude || '',
      original_total_price: totalprice,
      total_price: totalprice,
      item_count: itemCount,
      items: items,
      items_subtotal_price: subtotal,
      edd: edd
    };

    inFlight = true;
    fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        var updates = {};
        if (result && result.status == 200 && result.supriseGifts) {
          (result.supriseGifts.addItemsToCart || []).forEach(function (it) { updates[it.variantId] = 1; });
          (result.supriseGifts.removeItemsFromCart || []).forEach(function (it) { updates[it.variant_id] = 0; });
        }
        // Mark this cart state reconciled; if updates fire, the next render carries a new
        // signature and reconciles once more (converging to "no changes").
        lastSig = signature;
        if (!Object.keys(updates).length) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function () { if (typeof opts.onChange === 'function') opts.onChange(); });
      })
      .catch(function (err) { if (window.console) console.error('[StickyCart] surprise-gift', err); })
      .then(function () {
        inFlight = false;
        // A render arrived while we were busy — re-reconcile the latest cart state.
        // The signature guard makes this a no-op once the cart is settled (no loop).
        if (pending) { pending = false; apply(lastScope, lastOpts); }
      });
  }

  window.StickyCartSurpriseGift = { apply: apply };
})();
